import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as select from '../data/selector'
import ReCAPTCHA from "react-google-recaptcha"
import { Header, Input, Icon, Table, Select, Form, Button, Label } from "semantic-ui-react";
import Group_724 from "../../../image/Group_724.png"
import Group_732 from "../../../image/Group_732.png"
import { Formik, Field, Form as FormikForm } from "formik";
import { FormikInputComponent, FormikSelectComponent } from "../../../utilities/formUtils";
import countryxml from "../../../store/country_1.xml"
import statexml from "../../../store/state_1.xml"
import cityxml from "../../../store/city.xml"
import currencyxml from "../../../store/currency.xml"
import axios from "axios";
import countryToCurrency from "country-to-currency"; // countryToCurrency[ 'US' ] 
import lookup from "country-code-lookup"; // lookup.byCountry('United Kingdom')
import { GetCountries, GetState, GetCity } from "react-country-state-city";
// {
//     "id": 101,
//     "name": "India",
//     "iso3": "IND",
//     "iso2": "IN",
//     "numeric_code": "356",
//     "phone_code": "91",
//     "capital": "New Delhi",
//     "currency": "INR",
//     "currency_name": "Indian rupee",
//     "currency_symbol": "₹",
//     "tld": ".in",
//     "native": "भारत",
//     "region": "Asia",
//     "subregion": "Southern Asia",
//     "latitude": "20.00000000",
//     "longitude": "77.00000000",
//     "emoji": "🇮🇳",
//     "hasStates": true
//   }
const CompanyRegistration_two = (props) => {
    const isSaving = useSelector(state => select.isSaving(state, props));
    let [countryOptions, setcountryOptions] = useState([]);
    let [stateOptions, setstateOptions] = useState([]);
    let [cityOptions, setcityOptions] = useState([]);
    let [selectedState, setselectedState] = useState("Select State");
    let [selectedCity, setselectedCity] = useState("Select City");
    let [selectedCountryOption, setselectedCountryOption] = useState([]);
    let [selectedStateOption, setselectedStateOption] = useState([]);
    let [selectedCityOption, setselectedCityOption] = useState([]);
    let countryStatetrigger = (
        <Icon name='globe' className="countryStateIcon commonIcon" />
    )
    const onchangehandle = (e) => {
        if (e.target.name == "city") {
            props.setcityErrorclass("");
            props.setcityErrorMsg("");
        }
    }
    const getDDValue = (value, setFieldValue, values, userProps_options, field_name) => {
        let selectedoption = userProps_options.filter(function (model) {
            if (model.value == value) return model
        });
        if (field_name == "country") {
            setselectedCountryOption(selectedoption)
            props.setselectedCountry(value);
            fetchStateList(selectedoption.length > 0 ? selectedoption[0].key : props.selectedCountry)
            props.setselectedCountryCurrency(selectedoption.length > 0 ? selectedoption[0].currency : props.selectedCountryCurrency)
            setselectedCity("")
            props.setcountryErrorclass("");
            props.setcountryErrorMsg("");
            setFieldValue("city", "");
        } else if (field_name == "state") {
            setselectedStateOption(selectedoption)
            fetchCityList(selectedCountryOption.length > 0 ? selectedCountryOption[0].key : props.selectedCountry,selectedoption.length > 0 ? selectedoption[0].key : props.selectedState)
            setselectedState(value);
            props.setstateErrorclass("");
            props.setstateErrorMsg("");
        } else if (field_name == "city") {
            setselectedCityOption(selectedoption)
            setselectedCity(value);
            props.setcityErrorclass("");
            props.setcityErrorMsg("");
        }
    }
    let fetchStateList = (selectedcountryid) => {
        GetState(parseInt(selectedcountryid)).then((result) => {
            const stateOptions = [
                { key: "", value: "", text: "Select State", disabled: true },
                ...result.map((state) => ({
                    key: state.id,
                    value: state.name,
                    text: state.name,
                    code: state.iso3,
                    hasCities: state.hasCities
                })),
            ];
            setstateOptions(stateOptions)
            if (props.dataByemailId != undefined && props.dataByemailId?.data != null && props.dataByemailId?.data?.state != null && props.dataByemailId?.data?.state != "" && selectedState == "") {
                setselectedState(props.dataByemailId?.data?.state)
            }
        });
    }
    let fetchCityList = (selectedcountryid,selectedstateid) => {
        GetCity(parseInt(selectedcountryid),parseInt(selectedstateid)).then((result) => {
            const cityOptions = [
                { key: "", value: "", text: "Select State", disabled: true },
                ...result.map((city) => ({
                    key: city.id,
                    value: city.name,
                    text: city.name,
                    code: city.iso3
                })),
            ];
            setcityOptions(cityOptions)
            if (props.dataByemailId != undefined && props.dataByemailId?.data != null && props.dataByemailId?.data?.state != null && props.dataByemailId?.data?.state != "" && selectedState == "") {
                setselectedCity(props.dataByemailId?.data?.state)
            }
        });
    }
    useState(() => {
        GetCountries().then((result) => {
            const countryOptions = [
                { key: "", value: "", text: "Select Country", disabled: true },
                ...result.map((country) => ({
                    key: country.id,
                    value: country.name,
                    text: country.name,
                    code: country.iso3,
                    hasState: country.hasStates,
                    currency: country.currency
                })),
            ];
            setselectedCountryOption([{
                "key": 101,
                "value": "India",
                "text": "India",
                "code": "IND",
                "hasState": true,
                "currency": "INR"
              }])
            setcountryOptions(countryOptions)
            fetchStateList(101)
            props.setselectedCountryCurrency("INR")
        });
    }, [])
    return (
        <div style={{ display: props.displayparam }}>
            <div className="sign-up-wrapper">
                <div className="signUpContentContainer">
                    <div className="chat-wrapper">
                        <div className="chat-head">
                            <h4>RealBooks Virtual Assistant</h4>
                        </div>
                        <div className="chat-boxes-wrap stepWrap2">
                            <div className="chat-box-rb">
                                <img src={Group_724} />
                                <p>You are just 3 steps away!</p>
                            </div>
                            <div className="chat-box-rb">
                                <img src={Group_724} />
                                <p>Select your Business Location</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="signUpFormContainer">
                    <div className="signUpFormHelpContainerInner ">{/*signUpBigFormContainerInnerWidth*/}
                        <div className="sign-up-head">
                            <h3 className="signuptxt">Company Registration</h3>
                        </div>
                        <div className="progress-container">
                            <div className="progress" id="progress"></div>
                            <div className="circle green"></div>
                            <div className="circle green"></div>
                            <div className="circle green"></div>
                            <div className="circle active"></div>
                            <div className="circle"></div>
                            <div className="circle"></div>
                        </div>
                        <div className="sign-up-form-info">
                            <Form.Group widths={2}>
                                <div className="mb-3">
                                    <label for="Inputemail" className="sign-up-field-name form-label">Country</label>
                                    <Field
                                        id="country"
                                        name="country"
                                        noLabel="y"
                                        component={FormikSelectComponent}
                                        userProps={{
                                            options: countryOptions,
                                            getValue: getDDValue,
                                            // trigger:countryStatetrigger,
                                            fixedit: props.selectedCountry
                                        }}
                                        placeholder="Enter your country"
                                        style={{ marginTop: "11px" }}
                                        className={props.countryErrorclass}
                                        iserror={props.countryErrorclass != "" ? true : false}
                                        customErrorMsg={props.countryErrorMsg}
                                    />
                                </div>
                            </Form.Group>
                            <Form.Group widths={2}>
                                <div className="mb-3 mb-4">
                                    <label for="Inputemail" className="sign-up-field-name form-label">State</label>
                                    {selectedCountryOption.length > 0 && selectedCountryOption[0].hasState ?
                                        <Field
                                            id="state"
                                            name="state"
                                            noLabel="y"
                                            component={FormikSelectComponent}
                                            userProps={{
                                                options: stateOptions,
                                                getValue: getDDValue,
                                                // trigger:countryStatetrigger,
                                                fixedit: selectedState
                                            }}
                                            placeholder="Enter your state"
                                            style={{ marginTop: "11px" }}
                                            className={props.stateErrorclass}
                                            myChangeFunction={onchangehandle}
                                            iserror={props.stateErrorclass != "" ? true : false}
                                            customErrorMsg={props.stateErrorMsg}
                                        />
                                        :
                                        <Field
                                            id="state"
                                            name="state"
                                            noLabel="y"
                                            component={FormikInputComponent}
                                            icontoShow='building'
                                            iconPosition='left'
                                            placeholder="Enter the state"
                                            style={{ marginTop: "11px" }}
                                            className={props.stateErrorclass}
                                            myChangeFunction={onchangehandle}
                                            iserror={props.stateErrorclass != "" ? true : false}
                                            customErrorMsg={props.stateErrorMsg}
                                        />
                                    }
                                </div>
                            </Form.Group>
                            <Form.Group widths={2}>
                                <div className="mb-3 mb-4">
                                    <label for="Inputemail" className="sign-up-field-name form-label">City</label>
                                    {
                                        selectedStateOption.length > 0 && selectedStateOption[0].hasCities ?
                                            <Field
                                                id="city"
                                                name="city"
                                                noLabel="y"
                                                component={FormikSelectComponent}
                                                userProps={{
                                                    options: cityOptions,
                                                    getValue: getDDValue,
                                                    // trigger:countryStatetrigger,
                                                    fixedit: selectedCity
                                                }}
                                                placeholder="Enter your city"
                                                style={{ marginTop: "11px" }}
                                                className={props.cityErrorclass}
                                                myChangeFunction={onchangehandle}
                                                iserror={props.cityErrorclass != "" ? true : false}
                                                customErrorMsg={props.cityErrorMsg}
                                            />
                                            :
                                            <Field
                                                id="city"
                                                name="city"
                                                noLabel="y"
                                                component={FormikInputComponent}
                                                icontoShow='building'
                                                iconPosition='left'
                                                placeholder="Enter the city"
                                                style={{ marginTop: "11px" }}
                                                className={props.cityErrorclass}
                                                myChangeFunction={onchangehandle}
                                                iserror={props.cityErrorclass != "" ? true : false}
                                                customErrorMsg={props.cityErrorMsg}
                                            // userProps={{
                                            //     value:selectedCity
                                            // }}
                                            />
                                    }
                                </div>
                            </Form.Group>
                            <Form.Group widths={2}>
                                <div style={{ height: "20px" }}></div>
                            </Form.Group>
                            <Form.Group widths={2}>
                                <Button
                                    floated="left"
                                    type="button"
                                    size="medium"
                                    // color="green"
                                    className="btn-back"
                                    onClick={props.clickBackBtn}
                                    style={{ width: "94%", marginTop: "10px" }}
                                >Back</Button>
                                <Button
                                    floated="left"
                                    type="submit"
                                    size="medium"
                                    color="green"
                                    className="btn-next"
                                    // disabled = {isSaving ? true : false}                             
                                    // loading = {isSaving ? true : false}  
                                    style={{ width: "94%", marginTop: "10px" }}
                                >Next</Button>
                            </Form.Group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CompanyRegistration_two;